import { Component, ChangeDetectionStrategy, Inject, ViewChild, TemplateRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BookingByIdResponse } from 'app/experience/models/bookings/booking-by-id-response.model';

@Component({
	selector: 'tour-booking-details',
	templateUrl: './tour-booking-details.component.html',
	styleUrls: ['./tour-booking-details.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush
})

export class TourBookingDetailsComponent {
	@ViewChild('auditTrail') auditTrail!: TemplateRef<any>;
	auditTrailDialog!: MatDialogRef<any>;

	constructor(
		private dialog: MatDialog,
		protected dialogRef: MatDialogRef<TourBookingDetailsComponent>,
		@Inject(MAT_DIALOG_DATA) public tourBooking: BookingByIdResponse | null) {}

	viewAuditTrail() {
		this.auditTrailDialog = this.dialog.open(this.auditTrail, {	width: '685px', maxWidth: '685px' });
	}

	closeAuditTrail() {
		this.auditTrailDialog.close();
	}
}
